import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../components/Context/userContext';
import Header from '../../../components/Header';
import { headerLink } from '../../../navigation/function';
import { staffNavigation } from '../../../navigation/staff';
import { Button, Grid, InputAdornment, TextField, Typography, Pagination } from '@mui/material';
import { Search } from '@mui/icons-material';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';
import { RequestNextApi } from '../../../api/Request';
import { getCookie, setCookie } from '../../../utils/cookieHandle';
import { useRouter } from 'next/router';


import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { ProgressContext } from '../../../components/Context/progressContext';
import MarketingNavigation from '../../../navigation/marketing';
import Layout from '../../../components/Layout';
import { dateFormat } from '../../../utils/date-format';

export default function StaffNotifications() {
    const router = useRouter();
    const notificationLink = headerLink(staffNavigation.notification);
    const staffLink = headerLink(staffNavigation.staff);
    const { state: userContext, update: updateUser } = useContext(UserContext);
    const [keyword, setKeyword] = useState('');
    const [notification, setNotification] = useState([]);
    const [pages, setPages] = useState(null);
    const { update: updateProgress } = useContext(ProgressContext);

    useEffect(() => {
        const initPage = async () => {
            initNotifications(keyword, 1, 10);
        };
        initPage();
    }, []);

    const onClickSearch = async () => {
        updateProgress({ isLoading: true });
        const res = await notificationList(keyword, 1, 10);
        if (res.success) {
            setNotification(res.notificationItems);
            setPages(res?.pagination?.pages);
        }  else {
            ShowNotification.error('Notification search failed');
        }
        updateProgress({ isLoading: false });
    };

    const initNotifications = async (keywords, page, limit) => {
        updateProgress({ isLoading: true });
            const res = await notificationList(keywords, page, limit);
            if (res.success) {
                setNotification(res.notificationItems);
                setPages(res?.pagination?.pages);
            } else {
                ShowNotification.error('Member search failed');
            }
            updateProgress({ isLoading: false });
    };

    const notificationList = async (keywords, page, limit) => {
        try {
            const res = await RequestNextApi.post('/notifications/fetch-notification-list', {
                keywords,
                page,
                limit,
                jwtToken: getCookie('jwt-token'),
            });
            if (res.data && res.data.success) {
                return res.data;
            } else {
                ShowNotification.error('Notification search failed');
            }
        } catch (error) {
            ShowNotification.error('Notification search failed');
        }
    };

    const handlePageChange = async (event, value) => {
        updateProgress({ isLoading: true });
        const res = await notificationList(keyword, value, 10);
        if (res.success) {
            setNotification(res.notificationItems);
            setPages(res?.pagination?.pages);
        } else {
            ShowNotification.error('Member search failed');
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        updateProgress({ isLoading: false });
    };

    const onCreateNotification = async () => {
        router.push(`/staff/notification/create-notification`);
    };

    const editNotification = async (event,notification_id) => {
        event.preventDefault();
        router.push(`/staff/notification/edit-notification/`+notification_id);
    };

    const deleteNotification= async(event,id) => {
        event.preventDefault();
        updateProgress({ isLoading: true });
        try {
            console.log("delete");
            const res = await RequestNextApi.post('/notifications/delete-notification', {
                id,
                jwtToken: getCookie('jwt-token'),
            });
            if (res.data && res.data.success) {
                initNotifications(keyword, 1, 10);
            } else {
                ShowNotification.error('Notification search failed');
            }
        } catch (error) {
            ShowNotification.error('Notification search failed');
        }
        updateProgress({ isLoading: false });
    }

    return (
        <MarketingNavigation isAdmin>
            <Layout>
                {userContext?.user?.isStaff ? (
                    <div>
                        <Header>
                            <div>
                                Staff | {staffLink} | {notificationLink}
                            </div>
                        </Header>
                        <div className='bg-white p-4 mt-8 rounded-2xl'>
                            <Typography component='div' className='text-secondary-500 text-xl font-bold'>
                                Search the Notification
                            </Typography>
                            <Grid container spacing={2} className='items-center'>
                                <Grid item xs={12} md={6} xl={3}>
                                    <TextField
                                        size='small'
                                        fullWidth
                                        id='keyword'
                                        name='keyword'
                                        placeholder='Title, Message'
                                        className='my-3'
                                        onChange={(e) => setKeyword(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} xl={3}>
                                    <div className='flex justify-start 3xl:justify-end'>
                                        <div className='text-end space-x-3'>
                                            <Button variant='contained' className='bg-secondary-500 hover:bg-secondary-500' onClick={onClickSearch}>
                                                Search
                                            </Button>
                                            <Button variant='contained' className='bg-secondary-500 hover:bg-secondary-500' onClick={onCreateNotification}>
                                                Create Notification
                                            </Button>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <TableContainer>
                                <Table stickyHeader aria-label='sticky table'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align={'left'} style={{ minWidth: 150 }}>
                                                Title
                                            </TableCell>
                                            <TableCell align={'left'} style={{ minWidth: 150 }}>
                                                Message
                                            </TableCell>
                                            <TableCell align={'left'} style={{ minWidth: 150 }} className='bg-white'>
                                                Group
                                            </TableCell>
                                            <TableCell align={'left'} style={{ minWidth: 150 }}>
                                                Scheduled Date Time
                                            </TableCell>
                                            <TableCell align={'left'} style={{ minWidth: 150 }}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {notification.map((row) => {
                                            return (
                                                <TableRow hover role='checkbox' tabIndex={-1} key={row.id} className='bg-white'>
                                                    <TableCell align={'left'}>{row.title}</TableCell>
                                                    <TableCell align={'left'}>{row.message}</TableCell>
                                                    <TableCell align={'left'}>{row.group}</TableCell>
                                                    <TableCell align={'left'}>{dateFormat(row.event_date.date, 'hh:mm A dddd, MMMM D')}</TableCell>
                                                    <TableCell align={'left'}>
                                                        <div className='text-end space-x-3'>
                                                            <Button
                                                                type='submit'
                                                                variant='contained'
                                                                className='bg-secondary-500 hover:bg-secondary-500'
                                                                onClick={(e)=>{editNotification(e,row.id)}}
                                                            >
                                                                Edit
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color='secondary'
                                                                onClick={(e)=>{deleteNotification(e,row.id)}}
                                                            >
                                                                Delete
                                                            </Button>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div className='my-5 flex justify-end'>
                            <Pagination count={pages} onChange={handlePageChange} />
                        </div>
                    </div>
                ) : (
                    <></>
                )}
            </Layout>
        </MarketingNavigation>
    );
}

StaffNotifications.getLayout = (page) => <>{page}</>;
StaffNotifications.isStaff = true;
